<template>
  <div class="container">
    <h1 class="title">Hallo {{ userName }}</h1>
    <h2 class="subtitle">
      Willkommen im BackOffice!
    </h2>

    <div class="columns">
      <div class="column" v-for="metric in metrics" :key="metric.name">
        <div
          class="box has-background-primary has-text-white has-text-centered"
        >
          <p class="is-size-1">{{ metric.value }}</p>
          <p class="is-size-5">{{ metric.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import metricApi from '@/api/metrics-api'
export default {
  name: 'home',
  computed: {
    ...mapGetters({
      userName: 'userName',
    }),
  },
  data() {
    return {
      metrics: [],
    }
  },
  async mounted() {
    this.metrics = await metricApi.getDefaultMetrics()
  },
}
</script>
